import createEmptyCart from './createEmptyCart';

export default createEmptyCart;
